import { render, staticRenderFns } from "./CommissionDeferredForm.vue?vue&type=template&id=25b87ad4&"
import script from "./CommissionDeferredForm.vue?vue&type=script&lang=js&"
export * from "./CommissionDeferredForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports